"use client";

import { Box, Button, colors, Typography } from "@mui/material";
import { useRouter } from "@bprogress/next/app";
import { CloudOff, RefreshCw } from "lucide-react";

export default function VideoReuploadRequiredNotice() {
    const router = useRouter();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                gap: 1.5,
                p: 4,
                mt: 2,
                bgcolor: colors.grey[50],
                borderRadius: 2,
                border: "1px dashed",
                borderColor: colors.orange[300],
            }}
        >
            <CloudOff size={64} color={colors.orange[700]} />
            <Typography variant="h6" component="p">
                فایل استریم این ویدیو موجود نیست
            </Typography>
            <Typography variant="body2" color="text.secondary">
                این ویدیو قبل از فعال شدن سیستم استریم آپلود شده است. برای پخش، لازم است ویدیو دوباره آپلود شود تا فایل های استریم ساخته شوند.
            </Typography>
            <Button
                variant="outlined"
                color="warning"
                endIcon={<RefreshCw size={16} />}
                onClick={() => router.refresh()}
                sx={{ mt: 2 }}
            >
                تازه سازی صفحه
            </Button>
        </Box>
    );
}
